import Model from "../../classes/model/Model";
import User from "./User";
import Schedule from "./Schedule";
import Trainer from "./Trainer";

/**
 * @property {int} id
 * @property {int} old_id
 * @property {string} name
 * @property {string} phone
 * @property {int} schedule_id
 * @property {int} sms_id
 * @property {int} responsible_id
 * @property {int} client_id
 * @property {int} is_viewed
 * @property {int} pickup_date
 * @property {int} close_date
 * @property {int} status
 * @property {string} from
 * @property {string} roistat
 * @property {string} comment
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {Schedule} schedule
 * @property {Trainer} trainerOld
 * @property {Trainer} trainerNew
 * @property {User} creator
 * @property {User} updater
 */
export default class ScheduleReplace extends Model {

    relations() {
        return {
            schedule: {class: Schedule, many: false},
            trainerOld: {class: Trainer, many: false},
            trainerNew: {class: Trainer, many: false},
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

}
